<template>
  <div class="filterHeader">
    <div class="header-wrap">
      <el-select
        class="select-item"
        v-model="filterData.pkg"
        placeholder="选择产品"
        filterable
        @change="selectAdCount"
      >
        <el-option label="全部产品" :value="-1"> </el-option>
        <el-option
          v-for="item of appList"
          :key="item.package_name"
          :label="item.app_name + '（' + item.package_name + '）'"
          :value="item.package_name"
        >
        </el-option>
      </el-select>
      <el-select
        class="select-item"
        v-model="filterData.platType"
        placeholder="选择媒体渠道"
        filterable
        @change="selectAdCount"
      >
        <el-option label="全部渠道" :value="-1"> </el-option>
        <el-option label="今日头条" :value="1"> </el-option>
        <el-option label="广点通" :value="2"> </el-option>
        <el-option label="快手" :value="3"> </el-option>
      </el-select>
      <el-select
        class="select-item"
        v-model="filterData.advertiserId"
        placeholder="选择广告账号"
        filterable
        @change="changeAdvertiserId"
      >
        <el-option label="全部广告账号" :value="null"> </el-option>
        <el-option
          v-for="item of adCountList"
          :key="item.advertiser_id"
          :label="item.advertiser_name + '(' + item.advertiser_id + ')'"
          :value="item.advertiser_id"
        >
        </el-option>
      </el-select>
      <el-select
        class="select-item"
        :filter-method="dataFilter"
        v-model="filterData.campaignId"
        placeholder="选择广告组"
        filterable
      >
        <el-option label="全部广告组" :value="null"> </el-option>
        <el-option
          v-for="item of adGroupList"
          :key="item.campaign_id"
          :label="item.campaign_name"
          :value="item.campaign_id"
        >
        </el-option>
      </el-select>
      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px"
        value-format="yyyyMMdd"
        :clearable="false"
      >
      </el-date-picker>
      <el-button class="submit-btn" style="margin-left: 20px" @click="handleReset">重置</el-button>
      <el-button class="submit-btn" style="margin-left: 12px" type="primary" @click="clickSearch"
        >查询</el-button
      >
    </div>
  </div>
</template>

<script>
import { getPlatAdvertiser, getCampaign } from "@/api/tools.js";
import { getCommonProductList } from "@/api/api.js";
import moment from "moment";
export default {
  name: "filterHeader",
  props: {
    filterData: {
      type: Object,
    },
  },
  data() {
    return {
      appList: [],
      adCountList: [],
      adGroupList: [],
    };
  },
  created() {
    this.initSelectOptions();
  },
  methods: {
    initSelectOptions() {
      //产品
      getCommonProductList().then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
          this.selectAdCount(false);
        }
      });
    },
    selectAdCount(flag = true) {
      let parmas = {};
      this.filterData.pkg === -1 ? "" : (parmas.pkg = this.filterData.pkg);
      this.filterData.platType === -1 ? "" : (parmas.platType = this.filterData.platType);
      getPlatAdvertiser(parmas).then((res) => {
        if (res.code === "0000") {
          if (flag) {
            this.filterData.advertiserId = null;
            this.filterData.campaignId = null;
          }
          this.changeAdvertiserId();
          this.adCountList = res.advertiserDataDtoVos;
        }
      });
    },
    changeAdvertiserId(key = null) {
      getCampaign(
        this.filterData.advertiserId
          ? { advertiserId: this.filterData.advertiserId, campaignSearch: key }
          : { campaignSearch: key }
      ).then((res) => {
        if (res.code === "0000") {
          this.adGroupList = this.adCountList.length > 0 ? res.advertiserDataDtoVos : [];
        }
      });
    },
    dataFilter(val) {
      this.changeAdvertiserId(val);
    },
    clickSearch() {
      this.filterData.campaignName = this.adGroupList.find(
        (item) => item.campaign_id === this.filterData.campaignId
      )?.campaign_name;
      this.$emit("searchData", this.filterData);
    },
    handleReset() {
      this.filterData = {
        pkg: -1,
        platType: -1,
        advertiserId: null,
        campaignId: null,
        campaignName: null,
        time: [
          moment().subtract(7, "days").format("YYYYMMDD"),
          moment().subtract(1, "days").format("YYYYMMDD"),
        ],
      };
      this.$emit("searchData", this.filterData);
    },
  },
  watch: {
    filterData: {
      handler(val) {
        this.$emit("update:filterData", val);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.filterHeader {
  position: sticky;
  top: -16px;
  z-index: 99;
  .header-wrap {
    margin-top: 12px;
    .select-item {
      width: 200px;
      margin-right: 16px;
    }
    .multiple-select {
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .data-range {
      position: relative;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .submit-btn {
      padding: 0 20px;
    }
  }
}
</style>
